enum CTABtnType {
  NONE = 'none',
  BUTTON_ALIGN_LEFT = 'btn-alignment-left',
  BUTTON_ALIGN_CENTER = 'btn-alignment-center',
  BUTTON_ALIGN_RIGHT = 'btn-alignment-right',
}

export { CTABtnType };
